import { createSelector } from "@reduxjs/toolkit";

import { AppSelector } from "~/app/store";
import { StoreState } from "~/redux/reducers";

export const selectUsersFulfillmentCenter = (state: StoreState) => {
  return state.store?.usersFulfillmentCenter;
};

export const selectUsersFulfillmentCenterId = (state: StoreState) => {
  return state.store?.usersFulfillmentCenter?.fulfillmentCenterId;
};

export const selectClientSpecificInventoryAdjustmentReasonCodes = (
  state: StoreState
) => {
  return state.store?.usersFulfillmentCenter?.clientConfiguration
    ?.clientSpecificInventoryAdjustmentReasonCodes;
};

/** Selector to get Putaway Inventory Adjustment reason codes from the client configuration. */
export const selectPutawayAdjustmentReasonCodes: AppSelector<
  string[] | undefined
> = createSelector(
  [selectUsersFulfillmentCenter],
  (usersFulfillmentCenter) =>
    usersFulfillmentCenter?.clientConfiguration?.putawayAdjustmentReasonCodes
);

export const selectIsRecurringScheduleFc: AppSelector<boolean> = createSelector(
  [selectUsersFulfillmentCenter],
  (usersFulfillmentCenter) =>
    usersFulfillmentCenter?.batchConfiguration.toLowerCase() ===
    "recurring schedule"
);

export const selectSiteFcAbbreviationTrimmed = (
  state: StoreState
): string | undefined => {
  const abbr = state.workstations?.siteFcAbbreviation?.trim();
  return abbr || undefined;
};

/**
 * FC abbreviation for the SiteName header, sourced from the workstations
 * slice. Persisted in localStorage so it's available immediately on boot.
 */
export const selectSiteNameHeader = (state: StoreState): string => {
  return selectSiteFcAbbreviationTrimmed(state) ?? "";
};
